import React from 'react'
import styled from 'styled-components'

const Outer: React.FC<any> = ({ children, ...props }) => {
  return <Wrap {...props}>{children}</Wrap>
}

export default Outer

const Wrap = styled.div`
  position: relative;
  z-index: 10;
`
